function pw_post_product_modal_save(personalisationID, thumbURL){

 

}

$( document ).ready(function() {
  
  
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if (($("body").hasClass("template-product") || $(".product-detail").length ) && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if(($("body").hasClass("template-product") || $(".product-detail").length ) && pw_button.length){
      
      $("body").addClass("pw-product");
      
      
        
      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();


      function pwVariationChange(){

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
              $(".rimage-wrapper  img").attr("data-src", product_image_original);
              $(".rimage-wrapper  img").attr("data-bgset", product_image_original);
              $(".rimage-wrapper  img").attr("src", product_image_original);
              $(".rimage-wrapper  img").attr("srcset", product_image_original);

            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').val('Personalise');
            }


            
          }
          
          setTimeout(function(){ 
              $(".shopify-payment-button, .pwAddToCart").hide();
             
           },500);
        }

      }
      
      $(".option-selectors select").on("change", function(e){
		
         pwVariationChange();

      });

    }
  	
  	function replacePWimages(){
      
      var textArray = $(".item-list li.item .desc:contains('PersonalisationID')");

      textArray.each(function() {

        var cardID = this.innerText.match(/PersonalisationID:.*/);
        cardID = cardID[0];
        cardID = cardID.replace("PersonalisationID:", "").trim();
        cardID = cardID.match(/[^\s]+/);
        cardID = cardID[0];
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://shopify.printzware.com/thumbs/789/"+cardID+".jpg?r="+rand;
        $(this).parent().find("img").addClass("pwThumbImage");
        $(this).parent().find("img").attr("src",newSrc);
        $(this).parent().find("img").attr("srcset",newSrc);
        
       

      });
      
    }

    if ($("body").hasClass("template-cart")){
                
      setTimeout(function(){ 
      	replacePWimages();
      }, 2000);
      
    }

  });


